import { schemas } from './schemas';
import SchemaModel from '@chialab/schema-model';
import uuidv1 from "uuid/v1";
// import _ from 'lodash';

const schemaMap = Object.assign({}, ...schemas.map((schema) => ({
    [schema.title]: schema
})));

const _withDefaults = (Model, schema) => {
    return (data) => {
        const base = new Model(data);
        const defaults = Object.entries(schema.properties).map(([k, p]) => {
            let d = {};
            if (!(k in base))
                d[k] = p.default === undefined ? null : p.default;
            return d;
        });
        return Object.assign({}, ..._.cloneDeep(defaults), base);
    };
}

const _withPouch = (builder) => {
    return (data) => {
        const obj = builder(data);
        if (obj.created === null) {
            obj.created = Date.now();
        }
        if (obj._id === null) {
            if (obj.doc_type !== undefined || obj.doc_type !== null) {
                obj._id = obj.doc_type + ":" + uuidv1();
            } else {
                throw `doc_type must be defined`;
            }
        }

        if (obj._id && obj._id.search(obj.doc_type) !== 0) {
            throw `_id must begin with object_type [{doc.object_type}]` +
                ` instead found [(obj._id)]`
        }


        if (obj._rev == null) {
            delete obj._rev;
        }
        return obj;
    };
}

export const getModel = (name) => {
    let schema = schemaMap[name];
    return _withPouch(_withDefaults(SchemaModel.create(schema), schema));
};